module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-col', {
    staticClass: "toolbar uptool",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [(_vm.Limits.dealer_create) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.ShowAddDealer
    }
  }, [_vm._v("添加经销商")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "请输入内容",
      "size": "small"
    },
    model: {
      value: (_vm.inputMore),
      callback: function($$v) {
        _vm.inputMore = $$v
      },
      expression: "inputMore"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "slot": "prepend",
      "placeholder": "请选择"
    },
    slot: "prepend",
    model: {
      value: (_vm.selectMore),
      callback: function($$v) {
        _vm.selectMore = $$v
      },
      expression: "selectMore"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "联系人",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "电话",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "经销商",
      "value": "3"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.Find
    },
    slot: "append"
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.Refresh
    }
  }, [_vm._v("刷新")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listloading),
      expression: "listloading"
    }],
    staticStyle: {
      "width": "99.9%"
    },
    attrs: {
      "data": _vm.List,
      "border": "",
      "max-height": _vm.maxHeight
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "经销商名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "上级经销商",
      "prop": "superior.name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "国家",
      "prop": "country",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "省份",
      "prop": "province",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系人",
      "prop": "contact",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "电话",
      "prop": "phone",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }), _vm._v(" "), (_vm.Limits.dealer_delete || _vm.Limits.dealer_update) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "96"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.Limits.dealer_update) ? _c('el-button', {
          staticStyle: {
            "padding": "7px"
          },
          attrs: {
            "type": "primary",
            "icon": "el-icon-edit",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.Change(scope.$index, scope.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.Limits.dealer_delete) ? _c('el-button', {
          staticStyle: {
            "padding": "7px"
          },
          attrs: {
            "type": "danger",
            "icon": "el-icon-delete",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.Delete(scope.$index, scope.row)
            }
          }
        }) : _vm._e()]
      }
    }])
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar downtool",
    attrs: {
      "span": 24
    }
  }, [(_vm.Limits.deleteddealer_index) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.ShowDeleted
    }
  }, [_vm._v("显示已删除经销商")]) : _vm._e(), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.Pagesize,
      "current-page": _vm.Curpage,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加经销商",
      "visible": _vm.AddFormVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.AddFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经销商：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请填写经销商名称(必填)"
    },
    model: {
      value: (_vm.form.dealer),
      callback: function($$v) {
        _vm.$set(_vm.form, "dealer", $$v)
      },
      expression: "form.dealer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上级经销商：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择上级经销商(必选)"
    },
    model: {
      value: (_vm.form.Updealer),
      callback: function($$v) {
        _vm.$set(_vm.form, "Updealer", $$v)
      },
      expression: "form.Updealer"
    }
  }, _vm._l((_vm.Dealerlist), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经销商国家：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择国家(必选)"
    },
    on: {
      "change": _vm.CodeChange
    },
    model: {
      value: (_vm.form.countrycode),
      callback: function($$v) {
        _vm.$set(_vm.form, "countrycode", $$v)
      },
      expression: "form.countrycode"
    }
  }, _vm._l((_vm.Country_Code), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.country,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "id": "shengfeng",
      "label": "经销商省份：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择省份(必选)"
    },
    model: {
      value: (_vm.form.Country),
      callback: function($$v) {
        _vm.$set(_vm.form, "Country", $$v)
      },
      expression: "form.Country"
    }
  }, _vm._l((_vm.country), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.lable,
        "value": item.val
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请填写联系人(必填)",
      "maxlength": 10
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请填写电话(必填)",
      "maxlength": 11
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请填写邮箱(必填)"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注其他：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 1,
        maxRows: 6
      },
      "maxlength": 50,
      "auto-complete": "off",
      "placeholder": "(选填,字数少于50字)"
    },
    model: {
      value: (_vm.form.more),
      callback: function($$v) {
        _vm.$set(_vm.form, "more", $$v)
      },
      expression: "form.more"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.Subloading
    },
    on: {
      "click": _vm.Submit
    }
  }, [_vm._v("提 交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改经销商信息",
      "visible": _vm.changeFormVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.changeFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经销商：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请填写经销商名称(必填)"
    },
    model: {
      value: (_vm.form2.dealer),
      callback: function($$v) {
        _vm.$set(_vm.form2, "dealer", $$v)
      },
      expression: "form2.dealer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上级经销商：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择上级经销商(必选)"
    },
    model: {
      value: (_vm.form2.Updealer),
      callback: function($$v) {
        _vm.$set(_vm.form2, "Updealer", $$v)
      },
      expression: "form2.Updealer"
    }
  }, _vm._l((_vm.Dealerlist), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经销商国家：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择国家(必选)"
    },
    on: {
      "change": _vm.CodeChange2
    },
    model: {
      value: (_vm.form2.countrycode),
      callback: function($$v) {
        _vm.$set(_vm.form2, "countrycode", $$v)
      },
      expression: "form2.countrycode"
    }
  }, _vm._l((_vm.Country_Code), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.country,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "id": "shengfeng2",
      "label": "经销商省份：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择省份(必选)"
    },
    model: {
      value: (_vm.form2.Country),
      callback: function($$v) {
        _vm.$set(_vm.form2, "Country", $$v)
      },
      expression: "form2.Country"
    }
  }, _vm._l((_vm.country), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.lable,
        "value": item.val
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请填写联系人(必填)",
      "maxlength": 10
    },
    model: {
      value: (_vm.form2.name),
      callback: function($$v) {
        _vm.$set(_vm.form2, "name", $$v)
      },
      expression: "form2.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请填写电话(必填)",
      "maxlength": 11
    },
    model: {
      value: (_vm.form2.phone),
      callback: function($$v) {
        _vm.$set(_vm.form2, "phone", $$v)
      },
      expression: "form2.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请填写邮箱(必填)"
    },
    model: {
      value: (_vm.form2.email),
      callback: function($$v) {
        _vm.$set(_vm.form2, "email", $$v)
      },
      expression: "form2.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注其他：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 1,
        maxRows: 6
      },
      "maxlength": 50,
      "auto-complete": "off",
      "placeholder": "(选填,字数少于50字)"
    },
    model: {
      value: (_vm.form2.more),
      callback: function($$v) {
        _vm.$set(_vm.form2, "more", $$v)
      },
      expression: "form2.more"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.SubChangeloading
    },
    on: {
      "click": _vm.Submitchange
    }
  }, [_vm._v("提 交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "已删除经销商",
      "visible": _vm.DeleteVisible,
      "fullscreen": true,
      "before-close": _vm.Backchange
    },
    on: {
      "update:visible": function($event) {
        _vm.DeleteVisible = $event
      }
    }
  }, [_c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listloading2),
      expression: "listloading2"
    }],
    attrs: {
      "data": _vm.List2,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "经销商名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "上级经销商",
      "prop": "superior"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "国家",
      "prop": "country",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "省份",
      "prop": "province",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系人",
      "prop": "contact"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "电话",
      "prop": "phone"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.Limits.deleteddealer_enable) ? _c('el-button', {
          staticStyle: {
            "padding": "7px"
          },
          attrs: {
            "type": "success",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.Open(scope.$index, scope.row)
            }
          }
        }, [_vm._v("恢复")]) : _vm._e(), _vm._v(" "), (_vm.Limits.deleteddealer_delete) ? _c('el-button', {
          staticStyle: {
            "padding": "7px"
          },
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.Remove(scope.$index, scope.row)
            }
          }
        }, [_vm._v("彻底删除")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.Pagesize2,
      "current-page": _vm.Curpage2,
      "total": _vm.total2
    },
    on: {
      "current-change": _vm.handleCurrentChange2
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca52323a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/DealerManagement.vue
// module id = 1298
// module chunks = 1